import { useState } from 'react';

export const useModal = () => {
    const [visible, setVisible] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalButtons, setModalButtons] = useState(null);
    const [modalChildren, setModalChildren] = useState(null);

    const toggleModal = () => {
        toggleBodyOverflow();
        setVisible(!visible);
    };

    const toggleBodyOverflow = () => {
        document.body.style.overflow = visible ? 'visible' : 'hidden';
    };

    return {
        toggleModal,
        visible,
        modalTitle,
        setModalTitle,
        modalButtons,
        setModalButtons,
        modalChildren,
        setModalChildren
    };
};
